import React from 'react';
import { useAppDispatch } from '@/store/hooks';
import { loadTables, loadUserActions } from '@/actions';

export const useAppInit = () => {
  const dispatch = useAppDispatch();

  // TODO: use RTK-query instead.
  React.useEffect(() => {
    dispatch(loadTables(false));
    dispatch(loadUserActions());
  }, []);
};
